/**
 * Created by imranexpt on 07/04/2016.
 */
(function() {
    /** @ngInject */
    function Booking($http){
        var service = this;
        this.mealid = 0;
        this.amount = 2;
        this.seating_length = 0;
        this.date = null;
        this.time = null;
        this.firstname = '', this.lastname = '', this.email = '', this.phone = '',  this.mobile ='';
        this.comment = '';
        this.meal = {};
        this.errors = {};
        this.waitlist = 0;
        this.invitations = false;
        this.products = [];
        this.accept_terms = false;
        this.flags = [];
        this.id = 0;
        this.new = false;
        this.confirmed = 0;
        this.too_late_to_cancel = false;
        this.do_confirm = 0;
        this.widget_confirm_text = '';
        this.order_date = '';
        service.format_date = function(stamp, format){
            console.log("Checking", stamp);
			if(_.has(settings,'timezone')){
				return moment.tgz(stamp).tz(settings.timezone).format(format);
			}

            return moment.tgz(stamp).format(format);
        };
        service.requiredConfirmation = function(){
            if(service.waitlist == 1) return true;
            if(service.waitlist == 0 && service.confirmed != 0 && service.widget_confirm_text != '') return true;
            return false;
        };
        service.isConfirmBtn = function(){
            return this.waitlist == 0 && this.confirmed != 0 && this.widget_confirm_text != '' ? true : false;
        }
        service.getDate = function(format){
            if(service.id == 0) return '';
            return service.date.format(format);
        };
        service.setDate = function(date){
            service.date = moment.tgz(date);
        };
        service.getMealName = function(name){
            //console.log(service.meal.name, name);
            var mealname = _.isUndefined(name) ? service.meal.name : name;
            if(_.size(mealname) == 0) return mealname;
            return mealname;
            var matches;
            var regex = new RegExp(language + ':(\\w{1,})', 'i');
            matches = regex.exec(mealname);
            if(_.isNull(matches)) return '';
            return matches[1];
        };
        service.printTime = function(){
            return service.time;
        };
        service.setTime = function(time){
            service.time = time;
        };
        service.resetErrors = function(){
            service.errors = {firstname : false, lastname : false, email : false, phone : false, terms : false};
        };
        service.sendInvitation = function(emails, message){
            return $http.post("/reservation/api/booking/sendInvitations", {bookingid : service.id, emails : emails, message : message, hash : hash});
        };
        service.printDate = function(state){
            if(service.id == 0) return false;
            var _date = service.date; //moment.tgz(this.date);
            if(state == 'time') return _date.format('dddd');
            if(state == 'guest-details') return _date.format('D MMM');
            if(state == 'success') return _date.format('dddd D MMMM');
            return _date.format('D MMM');
        };
        service.getProductsTotal = function(){
            var total = 0;
            if(this.products){
                _.forEach(this.products, function(p){
                    total += p.amount*p.meal_price;
                });
            }
            return total;
        };
        service.initFromDbObj = function(book){
            for(var x in book){
                if(x != 'date' && x != 'seating_length')
                    service[x] = book[x];
            }
            this.setDate(book.date);

        };
        service.cancel = function(){
            return $http.post("/reservation/api/booking/cancelReservation", {bookingid : service.id, hash : hash});
        };
        service.confirmWithCC = function(stripeResponse){
            return $http.post("/reservation/api/booking/confirmPaymentWithCC", {booking : service.id, hash : hash, stripeResponse : stripeResponse});
        };
        service.getStripeIntent = function(){
            return $http.post("/reservation/api/booking/stripeCreateIntent", {booking : service.id, hash : hash});
        }
        service.saveStripePayment = function(paymentIntentId){
            return $http.post("/reservation/api/booking/stripeHandlePayment", {booking : service.id, hash : hash, payment_intent_id: paymentIntentId});
        }
        service.saveStripeCard = function(paymentIntentId){
            return $http.post("/reservation/api/booking/stripeHandlePayment", {booking : service.id, hash : hash, payment_intent_id: paymentIntentId});
        }
        service.getPendingInvitations = function(){
            return 10; //this.invitations.length;
        }


    }
    angular.module("Waiteraid").service('Booking',Booking);
})();
